import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { newsAPI } from "../../services/api";
import { motion } from "framer-motion";

const NewsSection = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await newsAPI.getRecent(5);
        setNews(response.data.data);
      } catch (error) {
        console.error("Failed to fetch news:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("th-TH", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  if (loading) {
    return (
      <section className="py-16 bg-white">
        <div className="container-custom">
          <div className="flex justify-center">
            <div className="spinner"></div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center mb-8">
          <h2
            className="text-3xl md:text-4xl font-bold text-primary-500 relative"
            style={{
              paddingBottom: "1rem",
              borderBottom: "3px solid #FFBF07",
              width: "fit-content",
            }}
          >
            <i className="fas fa-newspaper mr-2 text-secondary-500"></i>
            ข่าวประชาสัมพันธ์
          </h2>
          <Link
            to="/news"
            className="btn-primary inline-flex items-center gap-2"
          >
            ดูทั้งหมด
            <i className="fas fa-arrow-right"></i>
          </Link>
        </div>

        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          {news.map((item, index) => (
            <motion.div
              key={item.news_id}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1 }}
              className="border-b last:border-b-0 hover:bg-gray-50 transition-colors"
            >
              <Link to={`/news/${item.news_id}`} className="block p-4">
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 bg-primary-100 rounded-full flex items-center justify-center text-primary-500">
                    <i className="fas fa-newspaper"></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="font-medium text-gray-800 mb-1 hover:text-primary-500">
                      {item.title}
                    </h3>
                    <span className="text-sm text-gray-500">
                      <i className="fas fa-calendar-alt mr-1"></i>
                      {formatDate(item.publish_date)}
                    </span>
                  </div>
                  <i className="fas fa-chevron-right text-gray-400 group-hover:text-primary-500 transition-colors"></i>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
